module.exports = __webpack_public_path__ + "static/media/4.ee1cfec0.jpg";